<template>
  <v-card height="100%" class="workout-card" v-bind:class="{ selected }">
    <v-card-title class="font-script justify-center">{{item.amounts[difficulty]}}</v-card-title>
    <v-card-text class="text-center font-weight-bold">{{item.text}}</v-card-text>
  </v-card>
</template>

<style scoped>
.workout-card {
  transition: all 0.4s;
}
.workout-card.selected {
  box-shadow: 0 0 8px 8px #2196F3;
}
.workout-card:not(.selected) {
  background: #E0E0E0;
}
</style>

<script>
export default {
  name: 'workout-card',
  props: [ 'item', 'difficulty', 'selected' ]
}
</script>
